import { mount } from "@vue/test-utils";
import Mensaje from "@/views/Mensaje";

jest.mock("@/views/Mensaje", () => ({
  ...jest.requireActual("@/views/Mensaje"),
  methods: {
    getImage: jest.fn(),
    goLink: jest.fn()
  }
}));

describe("Mensaje test", () => {
  let wrapper;

  beforeEach(() => {
    const $route = {
      params: {
        mje: "error-5"
      }
    };

    wrapper = mount(Mensaje, {
      mocks: {
        $route
      }
    });
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component Mensaje", () => {
    expect(wrapper).toBeDefined();
  });
});
